<template>
  <v-container>
    <div class="mb-10"></div>
    <h1 class="display-4 text-center">404</h1>
    <br>
    <v-divider></v-divider>
    <br>
    <h3 class="text-center" style="font-weight: light">你找的页面不在这里</h3>
  </v-container>
</template>

<script>
export default {
  name: 'NotFoundPage'
}
</script>
